import {
    Component, AfterViewInit, ContentChildren, Directive,
    Input, QueryList, ElementRef, ViewChild, ViewChildren
} from '@angular/core';
import { CarouselItemDirective } from './carousel-item.directive';
import { animate, AnimationBuilder, AnimationFactory, AnimationPlayer, style } from '@angular/animations';

@Directive({
    selector: '.carousel-item'
})

export class CarouselItemElement {

}

@Component({
    selector: 'app-carousel',
    exportAs: 'app-carousel',
    templateUrl: './carousel.component.html',
    styleUrls: ['./carousel.component.css']
})
export class CarouselComponent implements AfterViewInit {
    @ContentChildren(CarouselItemDirective) items: QueryList<CarouselItemDirective>;
    @ViewChildren(CarouselItemElement, { read: ElementRef }) private itemsElements: QueryList<ElementRef>;
    @ViewChild('carousel') private carousel: ElementRef;
    @Input() timing = '250ms ease-in';
    @Input() showControls = true;
    private player: AnimationPlayer;
    private itemWidth: number;
    private currentSlide = 0;
    carouselWrapperStyle = {}



    ngOnInit() {
    }



    next() {
        if (this.currentSlide + 1 === this.items.length) {
            return;
        }

        this.currentSlide = (this.currentSlide + 1) % this.items.length;
        const offset = this.currentSlide * this.itemWidth;

        const myAnimation: AnimationFactory = this.builder.build([
            animate(this.timing, style({ transform: `translateX(-${offset}px)` }))
        ]);

        this.player = myAnimation.create(this.carousel.nativeElement);
        this.player.play();
    }

    prev() {
        if (this.currentSlide === 0) {
            return;
        }

        this.currentSlide = ((this.currentSlide - 1) + this.items.length) % this.items.length;
        const offset = this.currentSlide * this.itemWidth;

        const myAnimation: AnimationFactory = this.builder.build([
            animate(this.timing, style({ transform: `translateX(-${offset}px)` }))
        ]);

        this.player = myAnimation.create(this.carousel.nativeElement);
        this.player.play();
    }

    private buildAnimation(offset) {
        return this.builder.build([
            animate(this.timing, style({ transorm: `translateX(-${offset}px` }))
        ]);
    }

    constructor(private builder: AnimationBuilder) { }

    ngAfterViewInit() {
        setTimeout(() => {
            this.itemWidth = this.itemsElements.first.nativeElement.getBoundingClientRect().width;
            this.carouselWrapperStyle = {
                width: `${this.itemWidth}px`
            }
        }, 1000);
    }
}
